import { useParams, useNavigate } from "react-router-dom";
import ChatThreadList from "@/components/ChatThreadList";
import ChatThreadView from "@/components/ChatThreadView";

export default function Chat() {
  const { threadId } = useParams();
  const navigate = useNavigate();
  const showThread = Boolean(threadId);

  return (
    <div
      data-testid="chat-page"
      className="flex flex-col md:flex-row h-[calc(100vh-3.5rem-4rem)] md:h-[calc(100vh-3.5rem-2.5rem)] -mx-4 sm:-mx-8 -mt-6 sm:-mt-10 -mb-24 md:-mb-10"
    >
      <aside
        className={
          "border-white/10 bg-black flex-col " +
          "w-full md:w-80 md:shrink-0 md:border-r " +
          (showThread ? "hidden md:flex" : "flex")
        }
      >
        <ChatThreadList activeThreadId={threadId} />
      </aside>

      <section
        className={
          "flex-1 min-w-0 bg-black " +
          (showThread ? "flex flex-col" : "hidden md:flex md:items-center md:justify-center")
        }
      >
        {showThread ? (
          <ChatThreadView
            threadId={threadId}
            onBack={() => navigate("/app/chat")}
          />
        ) : (
          <p
            data-testid="chat-empty-pane"
            className="text-[#A1A1AA] font-body text-sm px-6 text-center max-w-xs"
          >
            Pick a conversation to start trading.
          </p>
        )}
      </section>
    </div>
  );
}
